import { FC } from 'react';
import Head from 'next/head';

export const GlobalHead: FC = () => {
  return (
    <Head>
      <meta name="robots" content="noindex" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/images/brand/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/images/brand/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/images/brand/favicon-16x16.png"
      />
      <link rel="manifest" href="/images/brand/site.webmanifest" />
      <link
        rel="mask-icon"
        href="/images/brand/safari-pinned-tab.svg"
        color="#ff9497"
      />
      <meta name="msapplication-TileColor" content="#ff9497" />
      <meta name="theme-color" content="#ffffff" />
      <meta property="og:type" content="website" />
    </Head>
  );
};
